import { styled } from "goober";

export const DragIndicator = styled("span")`
  display: block;
  flex-shrink: 0;
  width: 32px;
  height: 2px;
  border-radius: 10px;
  background: var(--border-alpha);

  &[data-orientation="horizontal"] {
    width: 2px;
    height: 32px;
  }
`;
